import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/services/config.service';
import { AuthService } from 'src/services/auth/authentication.service';
import { UserService } from 'src/services/user.service';

export function appInitializer(
  configService: ConfigService,
  authenticationService: AuthService,
  router: Router,
  userService: UserService
) {
  return () =>
    new Promise(async (resolve: any) => {
      await configService.loadConfig();
      authenticationService.loadConfig();
      userService.loadConfig();
      console.log('user')
      const user = JSON.parse(localStorage.getItem('user')!);
      // console.log(user)
      const url = window.location.href;
      // Extract 'auth' from the URL
      const part = new URL(url).pathname.split('/')[1];
      if (user) {
        userService.getProfile(user.id).subscribe((res) => {
          localStorage.setItem('user', JSON.stringify(res));
          authenticationService.userSubject.next(res);
        });
      } else {
        authenticationService.logout();
        if (part != 'auth') {
          router.navigate(['/auth/login']);
        }
      }

      await resolve(null);
    });
}
